export var UPDATE_DWNLD_STATE_DATA = "UPDATE_DWNLD_STATE_DATA";
